import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseButton } from '../components/base-button/Component.js';

var defaultColors = {"primary":"button__primary_xgedl","loader":"button__loader_xgedl","secondary":"button__secondary_xgedl","text":"button__text_xgedl","ghost":"button__ghost_xgedl","component":"button__component_xgedl","loading":"button__loading_xgedl","outlined":"button__outlined_xgedl","tertiary":"button__tertiary_xgedl","transparent":"button__transparent_xgedl","link":"button__link_xgedl"};
require('./default.mobile.css')

var invertedColors = {"primary":"button__primary_1oefv","loader":"button__loader_1oefv","secondary":"button__secondary_1oefv","text":"button__text_1oefv","ghost":"button__ghost_1oefv","component":"button__component_1oefv","loading":"button__loading_1oefv","outlined":"button__outlined_1oefv","tertiary":"button__tertiary_1oefv","transparent":"button__transparent_1oefv","link":"button__link_1oefv"};
require('./inverted.mobile.css')

var styles = {"size-32":"button__size-32_11lv3","size-40":"button__size-40_11lv3","size-48":"button__size-48_11lv3","size-56":"button__size-56_11lv3","size-64":"button__size-64_11lv3","size-72":"button__size-72_11lv3"};
require('./mobile.css')

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var ButtonMobile = forwardRef(function (restProps, ref) { return (React.createElement(BaseButton, __assign({}, restProps, { ref: ref, colorStylesMap: colorStyles, styles: styles }))); });

export { ButtonMobile };
